export const whatsAppURL = "https://wa.me/message/KFYW3QFWVHWBG1";
export const EmergencyWhatsAppURL = "https://wa.me/message/KFYW3QFWVHWBG1";

export const HomeVideoURL = "blob:portada-hz0n6VT946r4jhMeyE6K4XW9r5xdAB.mp4";
// blob:https://www.adaviv.com/15e05d2a-241c-44ed-8c13-f709c0f1e184
